import Head from 'next/head';
import { useRouter } from 'next/router';

import schemaMixin from '../../../data/mixins/jsonld';
import { CoreMetadataData } from '../../../types/components';

export type CoreMetadataProps = CoreMetadataData;

const CoreMetadata = (props: CoreMetadataProps): JSX.Element => {
  const router = useRouter();

  const {
    title,
    description,
    keywords,
    openGraphUrl,
    openGraphDescription,
    openGraphImage,
    openGraphTitle,
    canonicalUrl,
    twitterDescription,
    twitterImage,
    twitterTitle,
    faqSchema,
  } = props.fields;

  const schemaData = schemaMixin.methods.jsonld(props.fields, router.asPath);
  const hasSchemaData = schemaData != undefined;
  const hasFaqSchemaData = faqSchema.length;

  return (
    <Head>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:url" content={openGraphUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={openGraphTitle} />
      <meta property="og:description" content={openGraphDescription} />

      {openGraphImage && <meta property="og:image" content={openGraphImage} />}

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />

      {twitterImage && <meta name="twitter:image" content={twitterImage} />}

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {hasSchemaData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      )}

      {hasFaqSchemaData && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqSchema }} />
      )}
    </Head>
  );
};

export default CoreMetadata;
